module.exports = __webpack_public_path__ + "static/media/bg-notification.cd0f3040.png";